<template>
    <popup-modal ref="popup">
        <h2 class="titlee">{{ title }}</h2>
        <hr>
        <p class="messagee">{{ message }}</p>
        <div class="btns">
            <button class="cancel-btn" @click="_cancel">{{ cancelButton }}</button>
            <span class="ok-btn" @click="_confirm">{{ okButton }}</span>
        </div>
    </popup-modal>
</template>
<script>
import PopupModal from '@/components/PopupModal.vue'

export default {
    name: 'ConfirmDialogue',

    components: { PopupModal },

    data: () => ({
        // Parameters that change depending on the type of dialogue
        title: 'Confirmar Eliminación',
        message: 'Desea eliminar Registro ?', // Main text content
        okButton: 'Eliminar', // Text for confirm button; leave it empty because we don't know what we're using it for
        cancelButton: 'Volver', // text for cancel button
        
        // Private variables
        resolvePromise: undefined,
        rejectPromise: undefined,
    }),

    methods: {
        show(opts = {}) {
            this.title = opts.title
            this.message = opts.message
            this.okButton = opts.okButton
            if (opts.cancelButton) {
                this.cancelButton = opts.cancelButton
            }
            // Once we set our config, we tell the popup modal to open
            this.$refs.popup.open()
            // Return promise so the caller can get results
            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve
                this.rejectPromise = reject
            })
        },

        _confirm() {
            this.$refs.popup.close()
            this.resolvePromise(true)
        },

        _cancel() {
            this.$refs.popup.close()
            this.resolvePromise(false)
            // Or you can throw an error
            // this.rejectPromise(new Error('User cancelled the dialogue'))
        },
    },
}
</script>

<style scoped>
.titlee {
    color: #00174f;
    margin-bottom: 10px;
}

.messagee{
    color:#00174f;
    margin-top: 10px;
}
.btns {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.ok-btn {
    color: #FFF;
    background-color: #28a745;
    line-height: 2.5rem;
    cursor: pointer;
    padding: 0.5em 1em;
    border-radius: 5px;
    font-size: 14px;
    text-transform: uppercase;
}

.cancel-btn {
    padding: 0.5em 1em;
    background-color: #17a2b8;
    color: #fff;
    border-radius: 5px;
    font-weight: bold;
    font-size: 14px;
    text-transform: uppercase;
    cursor: pointer;
}
</style>

